import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActionListPage" */
	'pages/rights/Action/ActionListPage'));

export default [{ component, exact: true, path: '/actions' }];